import { DEBUG } from '@glimmer/env';
export { tracked } from '@glimmer/tracking';

let owner;

let _getOwner;

let setOwner;
let createCache;
let getValue;
let invokeHelper;
let isDestroyed;
let isDestroying;
let destroy;
let registerDestructor;
let associateDestroyableChild;
let waitForPromise;
let setHelperManager;
let helperCapabilities;
let environmentContextWasSet = false;
function getOwner(obj) {
  // eslint-disable-next-line
  if (typeof owner !== 'undefined' && obj instanceof owner) {
    return obj;
  }

  return _getOwner(obj);
}
function setEnviromentContext(env) {
  if (DEBUG) {
    if (environmentContextWasSet) {
      throw new Error('Attempted to set the glimmer-apollo environment context twice. This should only be set once.');
    }

    environmentContextWasSet = true;
  }

  owner = env.owner;
  setOwner = env.setOwner;
  _getOwner = env.getOwner;
  createCache = env.createCache;
  getValue = env.getValue;
  invokeHelper = env.invokeHelper;
  waitForPromise = env.waitForPromise;
  setHelperManager = env.setHelperManager;
  helperCapabilities = env.helperCapabilities;
  isDestroying = env.isDestroying;
  isDestroyed = env.isDestroyed;
  destroy = env.destroy;
  registerDestructor = env.registerDestructor;
  associateDestroyableChild = env.associateDestroyableChild;
}

export { associateDestroyableChild, createCache, destroy, getOwner, getValue, helperCapabilities, invokeHelper, isDestroyed, isDestroying, owner, registerDestructor, setEnviromentContext, setHelperManager, setOwner, waitForPromise };
